import * as TabsPrimitive from '@radix-ui/react-tabs';
import type { ComponentProps } from 'react';
import { cn } from '../../lib/utils';

export const Tabs = TabsPrimitive.Root;

export function TabsList({ className, ...props }: ComponentProps<typeof TabsPrimitive.List>) {
  return (
    <TabsPrimitive.List
      data-slot="tabs-list"
      className={cn(
        'inline-flex h-9 items-center justify-center gap-1 rounded-md bg-surface-sunken p-1 text-fg-muted',
        className,
      )}
      {...props}
    />
  );
}

export const tabsTriggerClassName =
  'inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-sm px-3 py-1 font-medium text-sm outline-none transition-colors ' +
  'focus-visible:ring-2 focus-visible:ring-ring/40 disabled:pointer-events-none disabled:opacity-50 ' +
  'data-[state=active]:bg-surface-raised data-[state=active]:text-fg data-[state=active]:shadow-xs ' +
  'hover:text-fg [&_svg]:size-4';

export function TabsTrigger({ className, ...props }: ComponentProps<typeof TabsPrimitive.Trigger>) {
  return (
    <TabsPrimitive.Trigger
      data-slot="tabs-trigger"
      className={cn(tabsTriggerClassName, className)}
      {...props}
    />
  );
}

export function TabsContent({ className, ...props }: ComponentProps<typeof TabsPrimitive.Content>) {
  return (
    <TabsPrimitive.Content
      data-slot="tabs-content"
      className={cn('mt-4 outline-none', className)}
      {...props}
    />
  );
}
